import React from 'react';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';

export default function ToggleButtons({
  onViewChange,
}) {
  const { listViewType = '' } = useSelector((e) => e);

  return (
    <div className="view-switch">
      <span
        onClick={() => onViewChange('table')}
        className={`view-switch-button ${listViewType === 'table' ? 'view-switch-button-selected' : ''}`}
        style={{
          borderRadius: 'var(--border-radius) 0 0 var(--border-radius)',
        }}
      >
        <Icon name="table" />
      </span>
      <span
        onClick={() => onViewChange('tile')}
        className={`view-switch-button ${listViewType === 'tile' ? 'view-switch-button-selected' : ''}`}
      >
        <Icon name="th-large" />
      </span>
    </div>
  );
}
